import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsCondicaoPagamentoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/permissao');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Permissao');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/permissao/findAll', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Permissao');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/permissao/create', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Permissao');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/permissao/findOne/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Permissao');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/permissao/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Permissao');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/permissao/delete/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Permissao');
    }
  }
}
